export default {
  labels: {
    hide: 'Ausblenden',
    show_order_summary: 'Bestellübersicht anzeigen',
  },
};
